import { request } from '@/utils/request'
import { HomeBanner } from './types'

/**
 * @description 获取首页banner图
 */
export function getHomeBanner(params: HomeBanner) {
  return request({
    url: '/zhongcaijie/h5/advertisement/getH5Advertisements',
    method: 'get',
    params,
  })
}

export function getHomeCenterBanner(params: HomeBanner) {
  return request({
    url: '/zhongcaijie/h5/advertisement/getH5Advertisements',
    method: 'get',
    params,
  })
}

/**
 * @description 获取首页icon
 */
export function getHomePageIcon(params: any) {
  return request({
    url: '/zhongcaijie/h5/homepage/icon/getHomePageIcon',
    method: 'get',
    params,
  })
}

/**
 * @description 获取用户是否关注公众号
 */
export function getUserIsSubscribe() {
  return request({
    url: '/wx/user/isSubscribe',
    method: 'post',
  })
}

/**
 * @description 获取首页推荐
 */
export function getHomePageRecommend() {
  return request({
    url: '/zhongcaijie/h5/homepage/recommend/getHomePageRecommend',
    method: 'get',
  })
}
